/**
 * relivConference.relivConferenceService
 */
angular.module('relivConference').service(
    'relivConferenceReportService',
    [
        'rcmApiLibService',
        'rcmLoading',
        'rcmApiLibMessageService',
        'translateFilter',
        'relivConferenceService',
        function (
            rcmApiLibService,
            rcmLoading,
            rcmApiLibMessageService,
            translateFilter,
            relivConferenceService
        ) {
            var self = this;

            var apiUrl = {
                conferenceReport: '/api/conference-report/{id}',
            };

            /**
             * getConferences
             * @param onSuccess
             * @param onError
             */
            self.getConferences = function (onSuccess, onError) {
                relivConferenceService.getAllConferences(
                    function (response) {
                        onSuccess(response.data);
                    },
                    function (response) {
                        onError(response.data);
                    }
                );
            };

            /**
             * getConferenceReport
             * @param conferenceId
             * @param onSuccess
             * @param onError
             */
            self.getConferenceReport = function (conferenceId, onSuccess, onError) {
                rcmApiLibService.get(
                    {
                        url: apiUrl.conferenceReport,
                        urlParams: {
                            id: conferenceId,
                        },
                        loading: function (loading) {
                            var loadingInt = Number(!loading);
                            rcmLoading.setLoading(
                                'relivConferenceReportService.getConferenceReport.loading',
                                loadingInt
                            );
                        },
                        success: function (response) {
                            onSuccess(
                                prepareReport(response.data)
                            );
                        },
                        error: function (response) {
                            onError(response);
                        },
                    }
                );
            };

            /**
             * prepareReport
             * @param report
             * @returns {*}
             */
            var prepareReport = function (report) {
                report.hasValues = {};

                for (var key in report) {

                    if (report[key] === null) {
                        report.hasValues[key] = false;
                        continue;
                    }

                    if (Array.isArray(report[key])) {
                        report.hasValues[key] = (report[key].length > 0);
                        continue;
                    }

                    if (report[key] instanceof Object) {
                        report.hasValues[key] = isEmptyObject(report[key]);
                        continue;
                    }

                    report.hasValues[key] = true;
                }

                return report;
            };

            /**
             * isEmptyObject
             * @param object
             * @returns {boolean}
             */
            var isEmptyObject = function (object) {
                return Object.keys(object).length > 0;
            };
        },
    ]
);
